import "./NoticeSection.css"
import NoticeCard from "../NoticeCard/NoticeCard";

function NoticeSection() {
  return (
    <div className="NoticeSection">
      <div className="NoticeCards" >
        <NoticeCard />
        <NoticeCard />
        <NoticeCard />
      </div>
    </ div>
  )
}

export default NoticeSection;